import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import * as types from '@reservedb/store/types'
import * as accountTypes from '@account/store/types'
import { IEDate, uGetDateFormat } from '@/modules/@appbase/util'

import ResourceEventList from './ResourceEventListDb.vue'
import { LoadingBar } from '@appbase/components/loading'

@Component({    
    components: {
        ResourceEventList,
        LoadingBar
    },

    computed: mapGetters({
        current: accountTypes.CURRENT,
        isLoading: types.CALENDAR_LOADING,
        currentDate: types.CALENDAR_DATE_CURRENT,
        rightPaneOpen: types.CALENDAR_RIGHTPANE_OPEN,
        
    })
})
export default class RightPaneDb  extends Vue {
    
    current!: account.TCurrent;
    isLoading!: boolean;
    currentDate!: reservedb.DateItem;
    rightPaneOpen!: boolean;
 
    
    getTimetext() {
         
        return this.current.userConfig.language === 'ko-KR' ? 
            `${uGetDateFormat('MM월 dd일', IEDate(this.currentDate.date))}` :
            `${uGetDateFormat('dd/MM', IEDate(this.currentDate.date))}`;
    }
 
}